import * as React from "react";
import { TextField } from "@material-ui/core";

export interface IProps {
    readonly label: string;
    readonly value: number;
    readonly isInteger?: boolean;

    readonly min?: number;
    readonly max?: number;

    readonly fullWidth?: boolean;

    readonly onChanged: (value: number) => void;
}

interface IState {
    readonly value: string;
    readonly isInvalid: boolean;
}

function tryParseInt(
    strValue: string | null | undefined,
    min: number | undefined,
    max: number | undefined): number | undefined {

    if (strValue === null || strValue === undefined) {
        return undefined;
    }

    if (strValue.length === 0) {
        return undefined;
    }

    const value = parseInt(strValue);
    if (isNaN(value)) {
        return undefined;
    }

    if (min !== undefined && value < min) {
        return undefined;
    }

    if (max !== undefined && value > max) {
        return undefined;
    }

    return value;
}

function tryParseFloat(
    strValue: string | null | undefined,
    min: number | undefined,
    max: number | undefined): number | undefined {

    if (strValue === null || strValue === undefined) {
        return undefined;
    }

    if (strValue.length === 0) {
        return undefined;
    }

    const value = Number.parseFloat(strValue);
    if (isNaN(value)) {
        return undefined;
    }

    if (min !== undefined && value < min) {
        return undefined;
    }

    if (max !== undefined && value > max) {
        return undefined;
    }

    return value;
}

export class NumberField extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            value: props.value.toString(),
            isInvalid: false
        };
    }

    public render(): React.ReactElement {
        const props = this.props;

        const onChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
            const parsedValue = props.isInteger ? 
                tryParseInt(e.target.value, props.min, props.max) :
                tryParseFloat(e.target.value, props.min, props.max);
    
            if (parsedValue !== undefined) {
                this.setState({
                    value: parsedValue.toString(),
                    isInvalid: false
                });
                
                props.onChanged(parsedValue);
            } else {
                this.setState({
                    value: e.target.value,
                    isInvalid: true
                });
            }
        };
        
        return (
            <TextField
                size="small"
                margin="dense"
                type="number"
                label={this.props.label}
                value={this.state.value}
                onChange={onChanged}
                error={this.state.isInvalid}
                fullWidth={this.props.fullWidth}
            />
        );
    }

    public componentDidUpdate(prevProps: IProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value.toString(),
                isInvalid: false
            });
        }
    }
}